<script>
  import {
    g_tabs,
    g_activeTab,
    g_showLineNumbers,
    g_darkTheme
  } from "./common.js";
  import { afterUpdate } from "svelte";
  import { config } from "./config";

  let activeTab = 0;
  let showSpinner = false;
  let showLineNumbers = true;
  let darkTheme = false;
  let tabs_value = [];
  var readOnlyCodeMirror;
  export let newcontent = "";

  const reRenderActiveTab = () => {
    showSpinner = true;
    // fnShowLoader(true);
    var code_snippet = document.getElementById("codesnippet_readonly");
    var b64image = document.getElementById("b64image");
    if (code_snippet == undefined) return;

    let isCode = true;
    if (tabs_value.length > 0) {
      if (isExtensionImageFile(tabs_value[activeTab].extension)) {
        if (tabs_value[activeTab].content.indexOf("data:image") > -1) {
          code_snippet.style.display = "none";
          b64image.parentNode.style.display = "block";
          b64image.style.width = "unset";
          isCode = false;
          if (tabs_value[activeTab].content.indexOf("data:image/svg+xml") > -1)
            b64image.style.width = "100px";
        }
      }
    }

    if (isCode) {
      code_snippet.style.display = "block";
      b64image.parentNode.style.display = "none";
      code_snippet.innerHTML = "";
      readOnlyCodeMirror = CodeMirror(code_snippet, {
        theme: darkTheme ? config.theme.dark : config.theme.light,
        lineNumbers: showLineNumbers,
        readOnly: "nocursor",
        value: tabs_value[activeTab] ? tabs_value[activeTab].content : ""
      });
      readOnlyCodeMirror.setSize(null, "100%");
    } else {
      b64image.src = tabs_value[activeTab] ? tabs_value[activeTab].content : "";
    }

    var tabel = document.getElementsByClassName("tablink")[activeTab];

    try {
      if (tabel != undefined) tabel.scrollIntoViewIfNeeded();
    } catch(e) {
      if (tabel != undefined) tabel.scrollIntoView();
    }
    showSpinner = false;
    // fnShowLoader(false);
    const darkThemeColor = "#282A36",
      lightThemeColor = "#FFF";
    document.getElementsByClassName(
      "middle"
    )[1].style.backgroundColor = darkTheme ? darkThemeColor : lightThemeColor;
    document.getElementsByClassName(
      "CodeMirror"
    )[0].style.backgroundColor = darkTheme ? darkThemeColor : lightThemeColor;
    document.getElementsByClassName("left")[1].style.backgroundColor = darkTheme
      ? darkThemeColor
      : lightThemeColor;
    document.getElementsByClassName("left")[1].style.color = darkTheme
      ? "#ccc"
      : "#000";
  };
  const closePage = path => {
    tabs_value = tabs_value.filter(tab => tab.path !== path);
    activeTab -= 1;
    if (activeTab < 0) activeTab = 0;
  };
  const unsubscribe_tabs = g_tabs.subscribe(value => {
    tabs_value = value;
    activeTab = tabs_value.length - 1;
    if (activeTab < 0) activeTab = 0;
  });
  const unsubscribe_activetab = g_activeTab.subscribe(
    value => (activeTab = value)
  );
  const unsubscribe_showLineNumbers = g_showLineNumbers.subscribe(value => {
    showLineNumbers = value;
    if (reRenderActiveTab != undefined) reRenderActiveTab();
  });
  const unsubscribe_darkTheme = g_darkTheme.subscribe(value => {
    darkTheme = value;
    if (reRenderActiveTab != undefined) reRenderActiveTab();
  });

  afterUpdate(() => reRenderActiveTab());

  function fnShowLoader(ptrue) {
    showSpinner = ptrue;
    var ele_display = document.getElementsByClassName("loader")[0];
    if (ele_display == undefined) return;
    if (ptrue)
      document.getElementsByClassName("loader")[0].style.display = "block";
    else document.getElementsByClassName("loader")[0].style.display = "none";
  }
  function isExtensionImageFile(extension) {
    if (extension === ".png") return true;
    if (extension === ".jpg") return true;
    if (extension === ".svg") return true;
    if (extension === ".ico") return true;
    if (extension === ".gif") return true;
    return false;
  }
</script>

<style>
  .tablink {
    background-color: rgb(85, 85, 85);
    color: white;
    cursor: pointer;
    border: none;
    outline: auto;
    padding: 5px;
  }
  .tablink > .tabname {
    display: inline;
  }

  .tablink > div > div {
    max-width: 150px;
    display: inline-block;
    overflow: hidden;
  }

  .tablink:hover {
    background-color: #777;
  }

  .topright {
    float: right;
    cursor: pointer;
    position: relative;
    color: transparent;
    line-height: 5px;
  }

  .topright:hover {
    color: red;
  }

  .tabbarpanel {
    overflow-x: auto;
    background-color: unset;
  }
  .loader {
    border: 16px solid #f3f3f3;
    border-radius: 50%;
    position: fixed;
    border-top: 16px solid #3498db;
    width: 120px;
    height: 120px;
    -webkit-animation: spin 2s linear infinite; /* Safari */
    animation: spin 2s linear infinite;
    left: 50%;
    top: 35%;
    z-index: 1;
    display: none;
  }

  /* Safari */
  @-webkit-keyframes spin {
    0% {
      -webkit-transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
    }
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
</style>

<div class="w3-bar w3-small tabbarpanel">
  {#each tabs_value as tab, i}
    <button
      class="tablink"
      title={tabs_value[i].path}
      style="background-color:{activeTab === i ? 'rgb(48, 46, 46)' : 'rgb(85, 85, 85)'}"
      on:click={() => (activeTab = i)}>
      <div class="tabname">
        <div>{tab.name}</div>
      </div>
      <div
        on:click={() => {
          closePage(tabs_value[i].path);
        }}
        class="topright">
        ×
      </div>
    </button>
  {/each}
</div>

{#if showSpinner}
  <div class="loader" />
{/if}
